import React, { useContext, useState } from "react";
import AuthContext from "../../context/AuthContext.js";
import { FiChevronDown, FiChevronRight, FiDownload } from "react-icons/fi";
import DownloadPDF from "../../utils/DownloadPDF.js";

const TrainDetails = ({ trainDetails }) => {
  const { selectedSite, selectedSiteName } = useContext(AuthContext);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  const handleDownload = () => {
    DownloadPDF(selectedSite, selectedSiteName, trainDetails, setIsLoading);
  };

  const formatTrainId = (trainId) => {
    if (!trainId) return "N/A";
    const parts = trainId.split("_");
    if (parts.length !== 7) return trainId;
    const [year, month, day, hour, minute] = parts;
    return `${day}/${month}/${year} ${hour}:${minute}`;
  };

  const formatNumber = (value) => {
    if (value === undefined || value === null) return "N/A";
    return Number(value).toFixed(2);
  };

  const getTrainNumber = (trainNumber) => {
    if (trainNumber === null || trainNumber === "Train Number") return null;
    return trainNumber;
  };

  const getTrainName = (trainName) => {
    if (trainName === null || trainName === "Train Name") return null;
    return trainName;
  };

  const formattedDate = trainDetails.TrainId
    ? formatTrainId(trainDetails.TrainId)
    : "N/A";
  const trainNumber = getTrainNumber(trainDetails.TrainNumber);
  const trainName = getTrainName(trainDetails.TrainName);
  const noOfTempSensors = trainDetails.Nooftempsens || 0;

  return (
    <div className="bg-white rounded-xl shadow overflow-hidden mb-4">
      <div className="bg-blue-900 text-white p-3 rounded-t-xl flex flex-col md:flex-row md:items-center justify-between">
        <div className="flex flex-wrap items-center gap-4">
          <span>
            <span className="font-bold">Train Details:</span> {formattedDate}
          </span>
          {trainNumber && (
            <span>
              <span className="font-bold">Train Number:</span> {trainNumber}
            </span>
          )}
          {trainName && (
            <span>
              <span className="font-bold">Train Name:</span> {trainName}
            </span>
          )}
        </div>

        <div className="flex items-center justify-between mt-2 md:mt-0 w-full md:w-auto gap-2">
          {selectedSiteName && (
            <div className="text-sm font-semibold whitespace-nowrap text-left md:mr-4">
              {selectedSiteName}
            </div>
          )}

          <button
            onClick={handleDownload}
            className="text-white hover:text-gray-300 transition"
            aria-label="Download"
            disabled={isLoading}
          >
            {isLoading ? (
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            ) : (
              <FiDownload size={20} />
            )}
          </button>

          <button
            onClick={toggleCollapse}
            className="text-white hover:text-gray-300 transition"
            aria-label="Toggle Table"
          >
            {isCollapsed ? (
              <FiChevronRight size={20} />
            ) : (
              <FiChevronDown size={20} />
            )}
          </button>
        </div>
      </div>

      {!isCollapsed && (
        <div>
          <div className="hidden md:block">
            <table className="w-full text-xs">
              <tbody>
                <tr>
                  <td className="p-2 font-medium text-left">No. of Coaches</td>
                  <td className="p-2 text-center">
                    {trainDetails.NoBogi || "N/A"}
                  </td>
                  <td className="p-2 font-medium text-left">
                    Total No. of Axles
                  </td>
                  <td className="p-2 text-center">
                    {trainDetails.TotalNoOfAxles || "N/A"}
                  </td>
                  <td className="p-2 font-medium text-left">Type of Coaches</td>
                  <td className="p-2 text-center">
                    {trainDetails.Description || "N/A"}
                  </td>
                  <td className="p-2 font-medium text-left">Avg. Speed(Kmph)</td>
                  <td className="p-2 text-center">
                    {formatNumber(trainDetails.AvgSpeed)}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="p-2 font-medium text-left">No. of Locos</td>
                  <td className="p-2 text-center">
                    {trainDetails.NoLoco || "N/A"}
                  </td>
                  <td className="p-2 font-medium text-left">Atmospheric Temp(°C)</td>
                  <td className="p-2 text-center">
                    {formatNumber(trainDetails.AtmosphereTemp)}
                  </td>
                  <td className="p-2 font-medium text-left">Max. Axle Temp Diff.(°C)</td>
                  <td className="p-2 text-center">
                    {formatNumber(trainDetails.Max_Avg_Temp_Diff)}
                  </td>
                  <td className="p-2 font-medium text-left">Max. Avg. Axle Temp(°C)</td>
                  <td className="p-2 text-center">
                    {formatNumber(trainDetails.Max_Avg_Axle_Temp)}
                  </td>
                </tr>
                {noOfTempSensors >= 2 && (
                  <tr>
                    <td className="p-2 font-medium text-left">
                      Max. Axle LH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MaxAxlesTempMP)}
                    </td>
                    <td className="p-2 font-medium text-left">
                      Min. Axle LH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MinAxlesTempMP)}
                    </td>
                    <td className="p-2 font-medium text-left">
                      Max. Axle RH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MaxAxlesTempAP)}
                    </td>
                    <td className="p-2 font-medium text-left">
                      Min. Axle RH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MinAxlesTempAP)}
                    </td>
                  </tr>
                )}
                {noOfTempSensors >= 4 && (
                  <tr className="bg-gray-50">
                    <td className="p-2 font-medium text-left">
                      Max. Wheel LH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MaxWheelTempMP)}
                    </td>
                    <td className="p-2 font-medium text-left">
                      Min. Wheel LH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MinWheelTempMP)}
                    </td>
                    <td className="p-2 font-medium text-left">
                      Max. Wheel RH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MaxWheelTempAP)}
                    </td>
                    <td className="p-2 font-medium text-left">
                      Min. Wheel RH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MinWheelTempAP)}
                    </td>
                  </tr>
                )}
                {noOfTempSensors >= 6 && (
                  <tr>
                    <td className="p-2 font-medium text-left">
                      Max. Brake Disc LH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MaxBreakDiskTempMP)}
                    </td>
                    <td className="p-2 font-medium text-left">
                      Min. Brake Disc LH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MinBreakDiskTempMP)}
                    </td>
                    <td className="p-2 font-medium text-left">
                      Max. Brake Disc RH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MaxBreakDiskTempAP)}
                    </td>
                    <td className="p-2 font-medium text-left">
                      Min. Brake Disc RH(°C)
                    </td>
                    <td className="p-2 text-center">
                      {formatNumber(trainDetails.MinBreakDiskTempAP)}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="block md:hidden">
            <div className="space-y-4 text-xs p-4">
              <div className="flex justify-between px-4">
                <span className="font-medium text-left">No. of Coaches</span>
                <span>{trainDetails.NoBogi || "N/A"}</span>
              </div>
              <div className="flex justify-between px-4">
                <span className="font-medium text-left">Total No. of Axles</span>
                <span>{trainDetails.TotalNoOfAxles || "N/A"}</span>
              </div>
              <div className="flex justify-between px-4">
                <span className="font-medium text-left">Type of Coaches</span>
                <span>{trainDetails.Description || "N/A"}</span>
              </div>
              <div className="flex justify-between px-4">
                <span className="font-medium text-left">Avg. Speed(Kmph)</span>
                <span>{formatNumber(trainDetails.AvgSpeed)}</span>
              </div>
              <div className="flex justify-between px-4">
                <span className="font-medium text-left">No. of Locos</span>
                <span>{trainDetails.NoLoco || "N/A"}</span>
              </div>
              <div className="flex justify-between px-4">
                <span className="font-medium text-left">Atmospheric Temp(°C)</span>
                <span>{formatNumber(trainDetails.AtmosphereTemp)}</span>
              </div>
              <div className="flex justify-between px-4">
                <span className="font-medium text-left">Max. Axle Temp Diff.(°C)</span>
                <span>{formatNumber(trainDetails.Max_Avg_Temp_Diff)}</span>
              </div>
              <div className="flex justify-between px-4">
                <span className="font-medium text-left">Max. Avg. Axle Temp(°C)</span>
                <span>{formatNumber(trainDetails.Max_Avg_Axle_Temp)}</span>
              </div>
              {noOfTempSensors >= 2 && (
                <>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Max. Axle LH(°C)</span>
                    <span>{formatNumber(trainDetails.MaxAxlesTempMP)}</span>
                  </div>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Min. Axle LH(°C)</span>
                    <span>{formatNumber(trainDetails.MinAxlesTempMP)}</span>
                  </div>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Max. Axle RH(°C)</span>
                    <span>{formatNumber(trainDetails.MaxAxlesTempAP)}</span>
                  </div>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Min. Axle RH(°C)</span>
                    <span>{formatNumber(trainDetails.MinAxlesTempAP)}</span>
                  </div>
                </>
              )}
              {noOfTempSensors >= 4 && (
                <>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Max. Wheel LH(°C)</span>
                    <span>{formatNumber(trainDetails.MaxWheelTempMP)}</span>
                  </div>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Min. Wheel LH(°C)</span>
                    <span>{formatNumber(trainDetails.MinWheelTempMP)}</span>
                  </div>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Max. Wheel RH(°C)</span>
                    <span>{formatNumber(trainDetails.MaxWheelTempAP)}</span>
                  </div>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Min. Wheel RH(°C)</span>
                    <span>{formatNumber(trainDetails.MinWheelTempAP)}</span>
                  </div>
                </>
              )}
              {noOfTempSensors >= 6 && (
                <>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Max. Brake Disc LH(°C)</span>
                    <span>{formatNumber(trainDetails.MaxBreakDiskTempMP)}</span>
                  </div>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Min. Brake Disc LH(°C)</span>
                    <span>{formatNumber(trainDetails.MinBreakDiskTempMP)}</span>
                  </div>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Max. Brake Disc RH(°C)</span>
                    <span>{formatNumber(trainDetails.MaxBreakDiskTempAP)}</span>
                  </div>
                  <div className="flex justify-between px-4">
                    <span className="font-medium text-left">Min. Brake Disc RH(°C)</span>
                    <span>{formatNumber(trainDetails.MinBreakDiskTempAP)}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainDetails;